import request from '@/http/request'

export const getDownloadTaskList = () => {
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/order/listDownloadTask`)
}
export const downloadExcel = params => {
  return request.post(`${process.env.REACT_APP_API_URL}/cro/v1/order/downloadExcel`, params, {
    responseType: 'blob',
    uploadOrDownload: true
  })
}
export const downloadExcelV2 = fileName => {
  const safeName = encodeURIComponent(fileName)
  return request.get(`${process.env.REACT_APP_API_URL}/cro/v1/order/downloadExcelV2/${safeName}`)
}
